import React from 'react';
import { clsx } from 'clsx';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  separator?: React.ReactNode;
  className?: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, separator, className }) => {
  const defaultSeparator = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className="w-4 h-4 stroke-current"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
    </svg>
  );

  return (
    <div className={clsx('breadcrumbs text-sm', className)}>
      <ul>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const content = (
            <>
              {item.icon && <span className="mr-2">{item.icon}</span>}
              {item.label}
            </>
          );

          return (
            <li key={index}>
              {item.href && !isLast ? (
                <a href={item.href} onClick={item.onClick}>
                  {content}
                </a>
              ) : item.onClick && !isLast ? (
                <button onClick={item.onClick} className="btn-ghost">
                  {content}
                </button>
              ) : (
                <span className={!isLast ? 'cursor-pointer' : ''}>{content}</span>
              )}
              {!isLast && (separator || defaultSeparator)}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
